import { ScreenEnum, useScreen } from 'feature/screenMode'
import {
  ServicesListWithSearch,
  ServiceCentersDesktop,
  ServiceCentersTabletMobile,
} from 'feature/serviceCenters/components'
import { SetPageTypeProps, TService } from 'feature/serviceCenters/types'
import { TPoint } from 'feature/YandexMap/types'
import { SyntheticEvent, useEffect, useState } from 'react'
import { useActions, useAppSelector } from 'store/hooks'

type TServiceCentersViewSelect = SetPageTypeProps & {
  data: TService[]
  isLoading: boolean
}
// отображение нужного вида в зависимотси от устройства пользователя
export const ServiceCentersViewSelect = ({
  data,
  setPageType,
  isLoading,
}: TServiceCentersViewSelect) => {
  const { setServiceTab, setServiceMarks } = useActions()
  const [filteredServices, setFilteredServices] = useState<TService[] | null>()
  const [isServicesListLoading, setServicesListLoading] =
    useState<boolean>(true)
  const serviceListSearchText = useAppSelector(
    state => state.services.serviceListSearchText,
  )
  const servicePageTab = useAppSelector(state => state.services.servicePageTab)

  const screen = useScreen()

  const handleTabsChange = (
    event: SyntheticEvent,
    newValue: 'map' | 'list',
  ) => {
    setServiceTab(newValue)
  }

  useEffect(() => {
    if (!data) return

    if (serviceListSearchText) {
      const search = serviceListSearchText.toLowerCase()
      const filtered = data.filter(
        service => service?.address?.toLowerCase().includes(search),
      )
      setFilteredServices(filtered)
      return
    }

    setFilteredServices(data)
  }, [data, serviceListSearchText, servicePageTab])

  useEffect(() => {
    //добавляю отфильтрованные данные на карту
    if (filteredServices) {
      const mapMarks: TPoint[] = filteredServices?.map(service => {
        return {
          coordinates: [
            Number(service.coordinatesLatitude),
            Number(service.coordinatesLongitude),
          ],
          name: service.name,
          description: service.address || service.name,
          uuid: service.uuid,
        }
      })

      setServicesListLoading(false)
      setServiceMarks(mapMarks)
    }
  }, [filteredServices, servicePageTab])

  if (screen === ScreenEnum.desktop) {
    return (
      <ServiceCentersDesktop
        setPageType={setPageType}
        isServicesListLoading={isServicesListLoading}
      >
        <ServicesListWithSearch
          searchText={serviceListSearchText}
          filteredServices={filteredServices}
        />
      </ServiceCentersDesktop>
    )
  }

  return (
    <ServiceCentersTabletMobile
      tabValue={servicePageTab}
      setPageType={setPageType}
      handleChange={handleTabsChange}
      data={data}
      isLoading={isLoading}
    >
      <ServicesListWithSearch
        searchText={serviceListSearchText}
        filteredServices={filteredServices}
      />
    </ServiceCentersTabletMobile>
  )
}
